export const ClimbType = {
  BOULDERING: '1',
  ROUTES: '2',
};

export const GradeType = {
  US: '1',
  FRENCH: '2',
  UIAA: '3',
  US_INDOOR: '4',
};

export const ClimbStatus = {
  NOT_SET: '1',
  COMPLETE: '5',
  CHECKED_OFF: '6',
  CUT_SHORT: '7',
};

export const ApolloFetchPolicy = {
  CACHE_FIRST: 'cache-first',
  CACHE_AND_NETWORK: 'cache-and-network',
  NETWORK_ONLY: 'network-only',
  CACHE_ONLY: 'cache-only',
  NO_CACHE: 'no-cache',
};

export const LocalStorageKey = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  USER_ID: 'id',
  USER_SLUG: 'slug',
  UPDATE_VERSION: 'update-version',
  HIDDEN_NOTIFICATIONS: 'hidden-notifications',
  USER_UI_CONFIG: 'user-ui-config',
  LAST_REFRESHED_VERSION: 'last-refreshed-version',
};

export const GymMapDimensions = {
  HEIGHT: 600,
  WIDTH: 1000,
};

export const SetupNotificationIds = {
  CONTACTS_SETUP: 'CONTACTS_SETUP',
  COLOR_SETUP: 'COLOR_SETUP',
  SETTER_SETUP: 'SETTER_SETUP',
  WALL_SETUP: 'WALL_SETUP',
  FINAL_MESSAGE: 'FINAL_MESSAGE',
};

export const GymMetaCategory = {
  HOURS_INFO: '1',
  WAIVER: '2',
  CLASSES: '3',
  MEMBERSHIP: '4',
  CUSTOM: '5',
};

export const GymMetaCategoryNames = {
  [GymMetaCategory.HOURS_INFO]: 'Hours & Info',
  [GymMetaCategory.WAIVER]: 'Waiver',
  [GymMetaCategory.CLASSES]: 'Classes',
  [GymMetaCategory.MEMBERSHIP]: 'Membership',
  [GymMetaCategory.CUSTOM]: 'Custom',
};

export const GymMetaType = {
  URL_LINK: '1',
  TEXT: '2',
  SUBMENU: '3',
};

export const GymMetaTypeNames = {
  [GymMetaType.URL_LINK]: 'Url Link',
  [GymMetaType.TEXT]: 'Text',
  [GymMetaType.SUBMENU]: 'Submenu',
};

export const TagType = {
  CUSTOM: '1',
  MOVEMENT: '2',
  GRIP: '3',
  FOOTWORK: '4',
  GENERAL: '5',
  STYLE: '6',
  CONDITIONS: '7',
  START: '8',
  FINISH: '9',
  BOLDNESS: '10',
};

export const ChallengeLocationType = {
  ALL: '1',
  GYM_ONLY: '2',
  OUTDOOR_ONLY: '3',
  BOARD_ONLY: '4',
  INDOOR_ONLY: '5',
};

export const LocationType = {
  COUNTRY: '1',
  DESTINATION: '2',
  AREA: '3',
  SUBAREA: '4',
  BOARD: '5',
  BOARD_BRAND: '6',
  WALLAREA: '7',
};

export const SinglePointType = {
  START_HOLDS: '1',
  BOLTS: '2',
};

export const ChallengeScoringType = {
  RELATIVE: '1',
  ABSOLUTE: '2',
  CUSTOM: '3',
  RELATIVE_WITH_CUSTOM_OVERRIDE: '4',
  SPEED: '5',
  VOLUME: '6',
  SESSION_VOLUME: '7',
  REGISTERED_GRADE_VOLUME: '8',
};

export const CHALLENGE_TEMPLATES = {
  CUSTOM: {
    title: 'CUSTOM',
    items: [
      {
        id: 1,
        title: 'BLANK',
        description: 'Create a customized challenge from a blank template.',
        params: {},
      },
    ],
  },

  INDIVIDUAL: {
    title: 'INDIVIDUAL COMPETITION',
    items: [
      {
        id: 2,
        title: 'REDPOINT',
        description: 'Top 5 hardest sends per week wins. Add categories based on ability levels. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.ABSOLUTE,
          top_num_ascents: 5,
          score_interval_days: 7,
          has_categories: true,
          auto_assign_category: false,
          video_required: true,
          max_attempts_penalty: 100,
          name: 'Redpoint Challenge',
          description_short: 'Top 5 hardest sends per week wins.',
          description_long: 'Log your climbs and upload your beta videos. Your top 5 hardest sends per 7 days will be counted towards your final score. Beta videos are required for proof. Repeats not allowed. -1 point per attempt.',
          categories: [
            {
              id: -1,
              name: 'Recreational',
              min_grade: { id: 1, name: '' },
              max_grade: { id: 1, name: '' },
            },
            {
              id: -2,
              name: 'Intermediate',
              min_grade: { id: 1, name: '' },
              max_grade: { id: 1, name: '' },
            },
            {
              id: -3,
              name: 'Advanced',
              min_grade: { id: 1, name: '' },
              max_grade: { id: 1, name: '' },
            },
            {
              id: -4,
              name: 'Open',
              min_grade: { id: 1, name: '' },
              max_grade: { id: 1, name: '' },
            },
          ]
        },
      },
      {
        id: 3,
        title: 'VOLUME',
        description: 'Most sends of any difficulty wins. Bouldering & Routes allowed. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.VOLUME,
          climb_type_id: null,
          auto_assign_category: false,
          repeats_allowed: true,
          video_required: true,
          name: 'Volume Challenge',
          description_short: 'Most sends of any difficulty wins.',
          description_long: 'Log your climbs of any difficulty for a chance to win. Beta videos are required for proof. Repeats are allowed. 1pt per ascent.',
        },
      },
    ],
  },

  GOAL: {
    title: 'GOAL TRACKING',
    items: [
      {
        id: 4,
        title: 'VOLUME',
        description: 'Achieve the goal of 20 new ascents in 4 weeks to win. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.VOLUME,
          climb_type_id: null,
          auto_assign_category: false,
          points_target: 20,
          repeats_allowed: true,
          video_required: true,
          name: '20 Ascent Challenge',
          description_short: 'Achieve the goal of 20 new ascents in 4 weeks to win.',
          description_long: 'Log your climbs of any difficulty to reach the goal of 20 new ascents. Beta videos are required for proof. Repeats are allowed. 1pt per ascent.',
        },
      },
      {
        id: 5,
        title: 'SESSIONS',
        description: 'Achieve the goal of 10 sessions in 4 weeks to win. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.SESSION_VOLUME,
          climb_type_id: null,
          auto_assign_category: false,
          points_target: 10,
          repeats_allowed: true,
          video_required: true,
          name: '10 Session Challenge',
          description_short: 'Achieve the goal of climbing 10 sessions (days) in 4 weeks to win.',
          description_long: 'Log your climbs of any difficulty for 10 days to reach the goal. Beta videos are required for proof. Repeats are allowed. 1pt per day climbed.',
        },
      },
    ],
  },

  TEAM: {
    title: 'TEAM COMPETITION',
    items: [
      {
        id: 6,
        title: 'REDPOINT',
        description: 'Team with most hardest sends wins. Top 5 hardest sends per climber per week. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.ABSOLUTE,
          score_interval_days: 7,
          auto_assign_category: false,
          top_num_ascents: 5,
          team_min_size: 1,
          team_max_size: 5,
          has_teams: true,
          video_required: true,
          max_attempts_penalty: 100,
          name: 'Redpoint Team Challenge',
          description_short: 'Team with most hardest sends wins.',
          description_long: 'Log your climbs and upload your beta videos. Your top 5 hardest sends per 7 days will be counted towards your team\'s final score. Beta videos are required for proof. Repeats not allowed. -1 point per attempt.',
        },
      },
      {
        id: 7,
        title: 'VOLUME',
        description: 'Team with most sends of any difficulty wins. Bouldering & Routes. Videos Required.',
        params: {
          rp_challenge_scoring_type_id: ChallengeScoringType.VOLUME,
          climb_type_id: null,
          auto_assign_category: false,
          team_min_size: 1,
          team_max_size: 5,
          has_teams: true,
          repeats_allowed: true,
          video_required: true,
          name: 'Volume Team Challenge',
          description_short: 'Team with most sends of any difficulty wins.',
          description_long: 'Log your climbs of any difficulty for a chance to win. Beta videos are required for proof. Repeats are allowed. 1pt per ascent.',
        },
      },
    ],
  },
};

export const OUTDOOR_CLIMB_SORT = {
  NAME: 'NAME',
  GRADE: 'GRADE',
  ASCENTS: 'ASCENTS',
  BETA: 'BETA',
  DATE_ADDED: 'DATE_ADDED',
  DATE_UPDATED: 'DATE_UPDATED',
  PUBLISHED: 'PUBLISHED',
  VERIFIED: 'VERIFIED',
  AREA: 'AREA',
  SUBAREA: 'SUBAREA',
  WALL: 'WALL',
  DESCRIPTION: 'DESCRIPTION',
  ACCESS_DESCRIPTION: 'ACCESS_DESCRIPTION',
  TOPO_LINES: 'TOPO_LINES',
  PHOTO: 'PHOTO',
  ANGLE: 'ANGLE',
  RATING: 'RATING',
  BENCHMARK: 'BENCHMARK',
  PROTECTION_DESCRIPTION: 'PROTECTION_DESCRIPTION',
  FA_INFO: 'FA_INFO',
  TAGS: 'TAGS',
  LENGTH: 'LENGTH',
  ACCESS_ISSUES: 'ACCESS_ISSUES',
  ACCESS_ISSUES_DESCRIPTION: 'ACCESS_ISSUES_DESCRIPTION',
  CLOSED: 'CLOSED',
  CLOSED_DATE: 'CLOSED_DATE',
  OFFENSIVE: 'OFFENSIVE',
  KAYA_USER: 'KAYA_USER',
  BOLTS: 'BOLTS',
  PITCHES: 'PITCHES',
  TRAD: 'TRAD',
};
